const validations = {
  oldPassword: {
    required: true,
  },
  newPassword: {
    required: true,
  },
  confirmNewPassword: {
    required: true,
  },
};

export { validations };
